import React from 'react';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatTextSize } from '../../utils/monacoLargeText';

/**
 * One quiet line above an editor holding a large text — what VS Code says when
 * it turns features off for a large file, so nobody wonders where wrapping went.
 */
export default function LargeTextNotice({ chars }) {
  const { t } = useTranslation();
  return (
    <div
      className="large-text-notice flex flex-shrink-0 items-center gap-1.5 px-2 py-1 text-[11px] text-gray-500 dark:text-zinc-400"
      role="status"
    >
      <Info size={12} className="flex-shrink-0" aria-hidden="true" />
      <span className="truncate">{t('request.largeTextNotice', { size: formatTextSize(chars) })}</span>
    </div>
  );
}
